<template>
  <section class="main" v-if="aceiteTermoAssinado">
    <div class="container mt-5 mb-5 col-md-12">
      <Titulo title="Política de Privacidade e Termos de Uso" description="" />
    </div>
    <div class="container mb-5">
      <p>
        Política de Privacidade e Termos de Uso
        <strong class="text-success">aceito com sucesso.</strong><br />
        Entre em contato com seu consultor.
      </p>
    </div>
  </section>
  <section class="termo-aceite main" v-else>
    <div class="container mt-5 mb-5 col-md-12">
      <Titulo title="Política de Privacidade e Termos de Uso" description="" />
    </div>
    <div class="container mb-5">
      <p>
        <span style="color: #05428e"><strong>1. IDENTIFICAÇÃO</strong></span>
      </p>
      <p>
        A CDL/BH é uma entidade de classe sem fins econômicos, filiação
        política, partidária ou religiosa que atua há mais de 60 anos com a
        finalidade de integrar e desenvolver o comércio varejista e o setor de
        serviços de Belo Horizonte. Sua sede está estabelecida na Avenida João
        Pinheiro, nº 495, bairro Boa Viagem, Belo Horizonte/MG, CEP 30.130-185.
      </p>
      <p>
        Durante o período da pandemia do Covid-19, foram mantidos apenas os
        serviços essenciais da CDL/BH em sua sede, razão pela qual solicitamos
        que dê preferência para entrar em contato por meios eletrônicos
        especificados neste documento para privilegiar um bom e rápido
        atendimento.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            2. MAIS SOBRE NÓS</strong
          ></span
        >
      </p>
      <p><strong>Nosso compromisso:</strong></p>
      <p>
        Esta Política de Privacidade tem o propósito de ratificar o compromisso
        e o respeito da CDL/BH com relação às Leis de privacidade e proteção de
        dados pessoais, sendo aplicável ao atendimento do público externo
        através de seu Portal.
      </p>
      <p>
        O tratamento de dados pessoais da CDL/BH está de acordo com as
        diretrizes estabelecidas por esta Política, com as Leis aplicáveis e com
        as melhores práticas aplicáveis.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            3. PRINCÍPIOS RELATIVOS AO TRATAMENTO DE DADOS PESSOAIS</strong
          ></span
        >
      </p>
      <p>
        Em nossa atuação levamos os princípios a sério e protegemos os direitos
        dos usuários de forma adequada. Confira abaixo algumas das questões mais
        importantes sobre nossa governança de dados pessoais:
      </p>
      <p><strong>TRANSPARÊNCIA E NÃO DISCRIMINAÇÃO</strong></p>
      <p>
        A CDL/BH trata os dados pessoais de forma transparente e não permite
        qualquer tratamento discriminatório ou, de qualquer modo, contrário à
        Lei.
      </p>
      <p><strong>ADEQUAÇÃO, NECESSIDADE E FINALIDADE</strong></p>
      <p>
        Os dados pessoais tratados pela instituição são aqueles adequados e
        necessários às suas finalidades estatutárias, notadamente para
        disponibilizar soluções aos seus associados e ao público externo.
      </p>
      <p><strong>LIVRE ACESSO E QUALIDADE DOS DADOS</strong></p>
      <p>
        Garantimos a você, na qualidade de titular dos dados pessoais tratados,
        a consulta sobre o tratamento realizado, sua forma e duração de
        armazenamento, respeitando sempre os princípios do livre acesso e da
        qualidade aliados às melhores práticas de segurança da informação.
      </p>
      <p><strong>SEGURANÇA E PREVENÇÃO</strong></p>
      <p>
        Adotamos as melhores práticas de gestão de dados pessoais e de segurança
        da informação, exigindo de nossos prestadores de serviço a adoção de
        níveis de excelência para garantir que os dados pessoais tratados
        observarão as regras desta Política.
      </p>
      <p><strong>RESPONSABILIZAÇÃO E PRESTAÇÃO DE CONTAS</strong></p>
      <p>
        Sabemos que as atividades mais simples de nossa instituição envolvem a
        utilização de dados pessoais,<br />
        seja para a identificação do público externo ou de associados, seja para
        atender às finalidades<br />
        estatutárias e previstas nesta Política. Assim, asseguramos a existência
        de controles internos<br />
        adequados.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            4. COMO, QUANDO E POR QUE SEUS DADOS PESSOAIS SÃO TRATADOS?</strong
          ></span
        >
      </p>
      <p>
        O tratamento de dados pessoais em nosso Portal se dá através da coleta e
        análise de informações sobre a navegação do usuário. A associação, a
        adesão a quaisquer das soluções da CDL/BH, assim como as atividades
        realizadas pela organização estão sujeitas e adequadas à LGPD. Através
        da navegação em nosso Portal, nós permitimos que você customize os dados
        pessoais que<br />
        serão coletados por cookies.
      </p>
      <p>
        <strong
          >Em nosso site, utilizamos cookies e os classificamos da seguinte
          maneira:</strong
        ><br />
        ● Cookies obrigatórios: são necessários para permitir a sua navegação
        pelo nosso Portal.<br />
        ● Cookies de performance: são úteis para permitir um acesso mais ágil ao
        nosso Portal, pois armazenam alguns arquivos temporários em seu
        computador no carregamento de algumas páginas.<br />
        ● Cookies Funcionais: são úteis para manter a configuração de
        localização do usuário.<br />
        ● Cookies Estatísticos: coletam informações sobre a sua navegação em
        nosso site, como as páginas visitadas, o tempo permanecido em cada uma
        delas, faixa etária. Esclarecemos que somente quando o usuário realiza o
        login em nosso site como Associado, nós<br />
        teremos condição de identificá-lo.
      </p>
      <p>
        <strong
          >Em nosso atendimento pelo Portal, nós coletamos especificamente e
          conforme o caso:</strong
        ><br />
        ● Nome, código de cadastro, CNPJ ou CPF para identificação e atendimento
        dos associados;<br />
        ● Nome, contato telefônico e e-mail para o cadastro de novo
        associado;<br />
        ● Número IP de sua conexão, localização e dados de identificação do seu
        navegador (browser);<br />
        ● Número de contato por WhatsApp, quando solicitado pelo usuário o
        atendimento por chatbot;<br />
        ● Facebook_id, quando solicitado pelo usuário o atendimento pelo
        Facebook;<br />
        ● Nome, CPF, e-mail e contato telefônico, quando o consumidor quiser
        orientações sobre a<br />
        regularização de débitos ou consulta ao banco de dados restritivo de
        crédito.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            5. RESUMO DOS DADOS PESSOAIS TRATADOS PELA CDL/BH</strong
          ></span
        >
      </p>
      <p>
        Caso haja o atendimento de sua solicitação pelo Portal, dados pessoais
        deverão ser fornecidos para<br />
        viabilizar o acionamento de soluções da CDL/BH, conforme o caso, e se
        resumem àquilo que foi<br />
        expressamente informado pelo usuário e se resumem a:
      </p>
      <ul>
        <li>Nome,</li>
        <li>Telefone,</li>
        <li>WhatsApp,</li>
        <li>E-mail,</li>
        <li>CPF,</li>
        <li>CNPJ,</li>
        <li>Código do Associado.</li>
      </ul>
      <p>
        Esclarecemos ainda que durante sua navegação em nosso website, são
        coletados dados simples de sua navegação que envolvem as características
        de seu sistema operacional, versão do navegador (browser), tipo de
        equipamento utilizado (computador, tablet ou smartphone), sua
        localização e conexão IP, as páginas que você visitou dentro do nosso
        website e o tempo em que passou em cada uma e as palavras-chave
        pesquisadas por você que o trouxeram ao nosso website e a frequência de
        suas visitas<br />
        (vide informações sobre Cookies nesta Política).
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            6. CANAL DE ATENDIMENTO PARA SUAS DÚVIDAS</strong
          ></span
        >
      </p>
      <p>
        Caso você tenha alguma dúvida com relação ao tratamento de dados
        pessoais ou deseje saber mais detalhes sobre os critérios estabelecidos
        nesta Política, você poderá nos acionar a qualquer momento de acordo com
        nossos canais e horários de atendimento.
      </p>
      <p>
        Para evitar fraudes, todos os requerimentos relacionados a dados
        pessoais necessitam da confirmação da sua identidade, o que poderá
        ocorrer mediante o fornecimento das informações detalhadas nesta
        Política ou do fornecimento de documentos de identificação civil.<br />
        Suas dúvidas podem ser direcionadas ao Comitê Encarregado de Proteção de
        Dados Pessoais (“Comitê DPO”) através do e-mail
        encarregado@cdlbh.com.br.
      </p>
      <p>
        Listamos, abaixo, os principais requerimentos relacionados ao tratamento
        de dados pessoais:
      </p>
      <p>
        Confirmação e acesso: para você ter certeza se os seus dados pessoais
        foram ou continuam a ser<br />
        tratados.
      </p>
      <p>
        Correção: para corrigir qualquer informação inexata, incompleta ou
        desatualizada.
      </p>
      <p>
        Anonimização, bloqueio ou eliminação: garantimos a você, em todas as
        possibilidades permitidas pela Lei, o direito a solicitar que seus dados
        pessoais sejam anonimizados, bloqueados ou até mesmo eliminados.
      </p>
      <p>
        Compartilhamento: para que você entenda claramente que seus dados
        pessoais são hospedados em servidores de empresas especializadas que
        adotam e respeitam as melhores práticas de segurança da informação.
      </p>
      <p>
        Geralmente, as suas requisições serão respondidas muito rapidamente.
        Damos preferência para o atendimento em tempo real. Mas quando isso não
        for possível, garantimos que as informações simplificadas serão
        adequadamente prestadas em até 15 dias e que atendimentos complexos
        ocorrerão em até 60 dias.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            7. QUAL BASE LEGAL NOS AUTORIZA A TRATAR SEUS DADOS
            PESSOAIS?</strong
          ></span
        >
      </p>
      <p>
        O tratamento de dados pessoais em nosso Portal se dá apenas em situações
        bem delimitadas e mediante iniciativa do próprio usuário, esclarecemos
        que os dados pessoais são tratados mediante o seu consentimento; por
        legítimo interesse; para cumprir o contrato celebrado com associados ou
        novos associados; assim como para atender exigências legais.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            8. QUANDO E COM QUEM COMPARTILHAMOS DADOS DO ATENDIMENTO?</strong
          ></span
        >
      </p>
      <p>
        Poderemos compartilhar os seus dados pessoais com os terceiros que e
        relacionam diretamente com a instituição, principalmente:<br />
        • Provedores de hospedagem na nuvem;<br />
        • Provedores de backup;<br />
        • Com órgãos públicos quando for necessário cumprir obrigação legal,
        para a execução de políticas públicas e cumprimento de contratos.<br />
        • Com parceiros da CDL/BH em suas soluções para associados e mediante
        contexto específico solicitado por eles.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            9. POR QUANTO TEMPO GUARDAMOS SEUS DADOS PESSOAIS?</strong
          ></span
        >
      </p>
      <p>
        A CDL/BH se compromete a manter seus dados pessoais para atender às
        exigências legais. Assim,<br />
        podemos lhe esclarecer que alguns dados são mantidos pelo prazo de 06
        (seis) meses e outros até por<br />
        07 (sete) anos.<br />
        Os dados pessoais coletados através de Cookies em nosso Portal são
        armazenados por 05 anos.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            10. SEGURANÇA DE SEUS DADOS PESSOAIS</strong
          ></span
        >
      </p>
      <p>
        Nossa preocupação com a segurança dos seus dados pessoais é alta e
        relevante. Por isso, adotamos as tecnologias coerentes para evitar
        incidentes e exigimos de todos os nossos prestadores de serviço a adoção
        de práticas de excelência.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            11. O DESCARTE DOS SEUS DADOS PESSOAIS</strong
          ></span
        >
      </p>
      <p>
        Como medida do uso racional dos dados pessoais tratados pela CDL/BH,
        precisamos esclarecer que cada um deles tem um ciclo de vida próprio.
        Desta forma, são armazenadas as informações pelo período coerente e
        estabelecido pela legislação. Após o decurso desses prazos razoáveis, há
        a eliminação feita de forma automatizada.
      </p>
      <p>
        Caso você tenha dúvidas sobre este assunto, não deixe de entrar em
        contato.
      </p>
      <p>
        <span style="color: #05428e"
          ><strong
            ><br />
            12. CONSIDERAÇÕES FINAIS</strong
          ></span
        >
      </p>
      <p>
        Esta Política de Privacidade para o Portal deve ser interpretada de
        acordo com todos os demais documentos que integram as Políticas da
        CDL/BH e de acordo com a boa-fé objetiva. Todos esses documentos são
        atualizados e revisados periodicamente, razão pela qual é fundamental
        que você consulte o nosso site sempre que necessário. E para atender ao
        patamar de compliance necessário, pedimos que caso você tenha
        conhecimento de qualquer conduta ilegal ou antiética, assim como
        vazamento de dados, entre em contato imediatamente conosco.
      </p>
      <p>
        Queremos atuar de forma ética e transparente, garantindo a você todas as
        informações exigidas pela Lei.
      </p>
      <div class="form-check mt-3 py-3 px-4">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="checkAceite"
          value="1"
          id="defaultCheck1"
        />
        <label class="form-check-label mt-1" for="defaultCheck1">
          <strong>Estou de acordo com o termo acima.</strong>
        </label>
      </div>
      <div>
        <div class="row mt-5 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-3">
            <Botao
              title="ASSINAR TERMO"
              :class="{ disabled: loading || !checkAceite }"
              @click="!loading || checkAceite ? salvarAceite() : ''"
              nameClass="btn btn-success btn-lg btn-block font-weight-bold"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">SALVANDO...</span>
              <span v-else>ASSINAR TERMO</span>
            </Botao>
          </div>
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </section>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
export default {
  name: "TermoAceite",
  components: { Titulo, Botao },
  props: {
    cpfTitular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      paramsRota: {},
      checkAceite: false,
      aceiteTermoAssinado: false,
    };
  },
  methods: {
    async salvarAceite() {
      this.loading = true;

      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      let d = new Date();
      let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

      if (this.urlParams.token) {
        const dadosTermo = {
          dtAceite: date,
          ipOrigem: sessionStorage.ip,
          browserData: navigator.appVersion,
          token: this.urlParams.token,
        };

        await this.$http
          .post("/api/Consultor/AceitarTermoUso", dadosTermo)
          .then((response) => {
            if (response.status === 200) {
              this.aceiteTermoAssinado = true;
            }
            this.loading = false;
          })
          .catch(() => {
            this.$toast.open({
              message: "Erro ao assinar o termo, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
  },
  computed: {
    urlParams() {
      return this.$route.query;
    },
  },
};
</script>
<style scoped>
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
strong {
  font-weight: bolder;
}

element.style {
}
*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 20px;
}
li {
  display: list-item;
  text-align: -webkit-match-parent;
}
ul li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}
</style>
